"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligibilityReasonKindSchema = exports.ELIGIBILITY_REASON_KINDS = exports.eligibilityNotAssessedReasonSchema = exports.ELIGIBILITY_NOT_ASSESSED_REASONS = exports.eligibilityVerdictSchema = exports.ELIGIBILITY_VERDICTS = void 0;
const zod_1 = require("zod");
exports.ELIGIBILITY_VERDICTS = [
    'eligible',
    'partially_eligible',
    'not_eligible',
    'not_assessed',
];
exports.eligibilityVerdictSchema = zod_1.z.enum(exports.ELIGIBILITY_VERDICTS);
exports.ELIGIBILITY_NOT_ASSESSED_REASONS = ['no_ruleset'];
exports.eligibilityNotAssessedReasonSchema = zod_1.z.enum(exports.ELIGIBILITY_NOT_ASSESSED_REASONS);
exports.ELIGIBILITY_REASON_KINDS = ['failed', 'unresolved'];
exports.eligibilityReasonKindSchema = zod_1.z.enum(exports.ELIGIBILITY_REASON_KINDS);
//# sourceMappingURL=verdict.js.map